/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_10_Job_TrackingInputs */

const en_pricing_feature_10_job_tracking = /** @type {(inputs: Pricing_Feature_10_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 job tracking`)
};

const de_pricing_feature_10_job_tracking = /** @type {(inputs: Pricing_Feature_10_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 Stellen-Tracking`)
};

const fr_pricing_feature_10_job_tracking = /** @type {(inputs: Pricing_Feature_10_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 suivis d'emploi`)
};

const es_pricing_feature_10_job_tracking = /** @type {(inputs: Pricing_Feature_10_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 seguimientos de empleo`)
};

const it_pricing_feature_10_job_tracking = /** @type {(inputs: Pricing_Feature_10_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 tracciamento lavori`)
};

const nl_pricing_feature_10_job_tracking = /** @type {(inputs: Pricing_Feature_10_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 baantracking`)
};

const pl_pricing_feature_10_job_tracking = /** @type {(inputs: Pricing_Feature_10_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 śledzenie ofert pracy`)
};

const fi_pricing_feature_10_job_tracking = /** @type {(inputs: Pricing_Feature_10_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 työpaikan seurausta`)
};

const da_pricing_feature_10_job_tracking = /** @type {(inputs: Pricing_Feature_10_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 jobsporinger`)
};

const sv_pricing_feature_10_job_tracking = /** @type {(inputs: Pricing_Feature_10_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 jobbspårning`)
};

/**
* | output |
* | --- |
* | "10 job tracking" |
*
* @param {Pricing_Feature_10_Job_TrackingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_10_job_tracking = /** @type {((inputs?: Pricing_Feature_10_Job_TrackingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_10_Job_TrackingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_10_job_tracking(inputs)
	if (locale === "fr") return fr_pricing_feature_10_job_tracking(inputs)
	if (locale === "es") return es_pricing_feature_10_job_tracking(inputs)
	if (locale === "it") return it_pricing_feature_10_job_tracking(inputs)
	if (locale === "nl") return nl_pricing_feature_10_job_tracking(inputs)
	if (locale === "pl") return pl_pricing_feature_10_job_tracking(inputs)
	if (locale === "fi") return fi_pricing_feature_10_job_tracking(inputs)
	if (locale === "da") return da_pricing_feature_10_job_tracking(inputs)
	if (locale === "sv") return sv_pricing_feature_10_job_tracking(inputs)
	return en_pricing_feature_10_job_tracking(inputs)
});